import { AxiosInstance } from "axios";

export const Activityservice = (axiosInstance: AxiosInstance) => {
  const apiBaseUrlUser = "api/user";
  const apiBaseUrlAgenda = "api/agenda";
  const apiBaseUrlQrcode = "api/qrcode";

  return {
    getlistActivityAll: async () => {
      return await axiosInstance.get(`${apiBaseUrlAgenda}`).then((result) => result.data);
    },
    findByRefenceId: async (code?: string) => {
      return await axiosInstance.get(`${apiBaseUrlQrcode}/reference/${code}`).then((result) => result.data);
    },
    importfileExcel: async (agendaID: string, data: any) => {
      return await axiosInstance.post(`${apiBaseUrlUser}/agenda/${agendaID}`, data).then((result) => result.data);
    },
    findUserInAgneda: async (
      agendaId?: string,
      skip?: number,
      take?: number,
      searchParam?: { username?: string; ticket?: string; type?: string; order?: any; column?: any; customerName?: any }
    ) => {
      const params = {
        skip: skip,
        take: take,
        username: searchParam?.username,
        ticket: searchParam?.ticket,
        type: searchParam?.type,
        order: searchParam?.order,
        column: searchParam?.column,
        customerName: searchParam?.customerName,
      };
      return await axiosInstance.get(`${apiBaseUrlUser}/users/${agendaId}`, { params }).then((result) => result.data);
    },
    exportUserInAgnedaId: async (agendaId?: string, searchParam?: { username?: string; ticket?: string; type?: string }) => {
      const params = {
        username: searchParam?.username,
        ticket: searchParam?.ticket,
        type: searchParam?.type,
      };
      return await axiosInstance.get(`${apiBaseUrlUser}/users/export/${agendaId}`, { params }).then((result) => result.data);
    },
    checkIn: async (userId: string) => {
      return await axiosInstance.put(`${apiBaseUrlUser}/checkIn/${userId}`).then((result) => result.data);
    },
    removeCheckIn: async (userId: string) => {
      return await axiosInstance.put(`${apiBaseUrlUser}/removeCheckIn/${userId}`).then((result) => result.data);
    },
  };
};
